import { configureStore } from '@reduxjs/toolkit';
import authReducer from './features/authSlice';
import documentReducer from './features/documentSlice';
import logReducer from './features/logSlice'
import chatReducer from './features/chatSlice';
import urlTrainerReducer from './features/urlTrainerSlice';


export const store = configureStore({
  reducer: {
    auth: authReducer,
    documents: documentReducer,
    logs: logReducer,
    chat: chatReducer,
    urlTrainer: urlTrainerReducer,
  },
});
